import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import MarkdownWrapper from '../utils/markdown-wrapper'
import { saveNavTheme } from '../../reducers/nav'

const CharacterInterstitial = ({ dispatch, chapter, characterKeyIssue, status }) => {
    const [enableLinks, setEnableLinks] = useState(false)
    let color = characterKeyIssue.color

    useEffect(() => {
        if (status === 'ACTIVE') {
            if (['teal', 'blue', 'magenta', 'black'].includes(color)) {
                dispatch(saveNavTheme('white'))
            } else {
                dispatch(saveNavTheme('grey'))
            }
            setEnableLinks(true)
        } else if (status === 'PREVIOUS' || status === 'NEXT') {
            setTimeout(() => {
                setEnableLinks(false)
            }, 1000)
        }
    }, [status, dispatch, color])

    if (!chapter || status === 'OFF') {
        return null
    }

    return (
        <div className={`chapter-container ${status.toLowerCase()} ${enableLinks ? '' : 'disable-links'} character-interstitial ${color}-bg`}>
            <div className="interstitial-background" style={{ backgroundImage: `url(${chapter.background_image?.url})` }} />
            <div className="interstitial-content container">
                <MarkdownWrapper content={chapter.content} />
            </div>
        </div>
    )
}

export default connect()(CharacterInterstitial)
